import { ARENA_H, ARENA_W, type World } from "../sim";

export interface Camera {
  x: number;
  y: number;
}

export function pixelsPerUnit(viewW: number, viewH: number): number {
  return Math.max(28, Math.min(viewW / 22, viewH / 14.5));
}

export function screenToWorld(
  sx: number,
  sy: number,
  cam: Camera,
  viewW: number,
  viewH: number,
): { x: number; y: number } {
  const ppu = pixelsPerUnit(viewW, viewH);
  return {
    x: cam.x + (sx - viewW / 2) / ppu,
    y: cam.y + (sy - viewH / 2) / ppu,
  };
}

export function worldToScreen(
  x: number,
  y: number,
  cam: Camera,
  viewW: number,
  viewH: number,
): { x: number; y: number } {
  const ppu = pixelsPerUnit(viewW, viewH);
  return {
    x: viewW / 2 + (x - cam.x) * ppu,
    y: viewH / 2 + (y - cam.y) * ppu,
  };
}

export function followPlayer(cam: Camera, world: World, dt: number): void {
  const p = world.units.find((u) => u.id === world.playerId) ?? world.units[0];
  if (!p) return;
  const k = 1 - Math.pow(0.001, dt);
  cam.x += (p.pos.x - cam.x) * k;
  cam.y += (p.pos.y - cam.y) * k;
  const marginX = 6;
  const marginY = 4;
  cam.x = Math.min(ARENA_W - marginX, Math.max(marginX, cam.x));
  cam.y = Math.min(ARENA_H - marginY, Math.max(marginY, cam.y));
}
